export default __webpack_public_path__ + "static/media/4a3b8067fe3baabc.af304c6ae0da590af0cf885c9c8c897c.svg";